import { Component } from '@theme/component';

/**
 * Expand pads (sections/push-pads-expand.liquid). On screens that can hover, opening a card is pure
 * CSS (:hover / :focus-within). Touch screens have no hover: the first tap on a closed card opens it
 * (`is-open`) instead of following its link, the next tap follows the link.
 *
 * @extends {Component<{ cards: HTMLElement[] }>}
 */
class PadsExpand extends Component {
  #noHover = matchMedia('(hover: none)');

  /** @param {MouseEvent} event */
  handleCardClick(event) {
    const card = /** @type {HTMLElement} */ (event.target);
    if (!this.#noHover.matches || card.classList.contains('is-open')) return;

    event.preventDefault();
    for (const other of this.refs.cards) other.classList.toggle('is-open', other === card);
  }
}

if (!customElements.get('pads-expand')) {
  customElements.define('pads-expand', PadsExpand);
}
